"use client";

import React from "react";
import { ArrowRight, Layers } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
function ProjectsGrid() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-[400px] w-full animate-pulse rounded-xl bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-20 text-center">
        <p className="text-destructive mb-4">Đã xảy ra lỗi khi tải dữ liệu dự án.</p>
        <Button onClick={refetch} variant="outline">
          Thử lại
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex flex-col items-center justify-center py-20 text-center">
        <p className="text-muted-foreground mb-6 text-lg">Hiện chưa có dự án nào được cập nhật.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const technology = post.tags && post.tags.length > 0 ? post.tags[0].name : "Công nghệ cao";
      return <Link key={post.id} to={post.link || "#"} className="group block h-full" data-index={i}>
            <Card className="relative h-full overflow-hidden border-none bg-transparent shadow-none transition-all duration-500 hover:-translate-y-1">
              <div className="relative w-full overflow-hidden rounded-xl bg-muted">
                <AspectRatio ratio={4 / 3}>
                  {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-all duration-700 grayscale group-hover:scale-105 group-hover:grayscale-0" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                      <Layers className="h-12 w-12 opacity-20" />
                    </div>}
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-80" />

                  <div className="absolute bottom-4 left-4 z-20">
                    <Badge variant="default" className="bg-primary text-primary-foreground border-primary/20 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider shadow-lg backdrop-blur-sm">
                      {technology}
                    </Badge>
                  </div>

                  <div className="absolute inset-0 z-10 flex flex-col justify-end p-6 opacity-0 transition-all duration-500 group-hover:opacity-100">
                    <div className="translate-y-4 transform transition-transform duration-500 group-hover:translate-y-0">
                      <p className="mb-12 line-clamp-3 text-sm font-medium text-white/90 drop-shadow-md">
                        {post.excerpt ? post.excerpt.replace(/<[^>]*>?/gm, '') : "Khám phá các giải pháp công nghệ tiên tiến và đổi mới sáng tạo trong dự án này."}
                      </p>
                    </div>
                  </div>
                </AspectRatio>
              </div>

              <CardContent className="pt-4 px-1">
                <h3 className="text-xl font-bold leading-tight text-foreground transition-colors group-hover:text-primary">
                  {post.title}
                </h3>
                <div className="mt-2 flex items-center text-sm font-medium text-primary opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  Xem chi tiết <ArrowRight className="ml-1 h-4 w-4" />
                </div>
              </CardContent>
            </Card>
          </Link>;
    })}
    </div>;
}
export default function SolutionsAndTechnology() {
  const wp_query_params = {
    per_page: 6,
    orderby: "date",
    order: "desc",
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="giải-pháp-công-nghệ" className="bg-background py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <div className="mb-4 flex items-center gap-2 text-primary">
              <span className="h-px w-8 bg-primary"></span>
              <span className="text-sm font-bold uppercase tracking-widest">Dự án & Công nghệ</span>
            </div>
            <h2 className="text-4xl font-bold tracking-tight text-foreground md:text-5xl lg:text-6xl">
              Giải pháp <span className="text-primary">Đột phá</span>
            </h2>
            <p className="mt-6 text-lg text-muted-foreground">
              NUCETECH tiên phong trong việc áp dụng các công nghệ xây dựng tiên tiến, mang lại hiệu quả tối ưu và bền vững cho mọi công trình.
            </p>
          </div>
          
          <Link to="/SolutionsPage">
            <Button size="lg" className="group min-w-[160px]">
              Tất cả dự án
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>

        <PostsProvider wp_query={{
        per_page: 6,
        orderby: "date",
        order: "desc",
        status: ["publish"]
      }} className="w-full">
          <ProjectsGrid />
        </PostsProvider>
      </div>
    </section>;
}